import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          {/* Logo Section */}
          <Col md={3} className="text-center text-md-left">
            <img className="logo" src="/images/logo.png" alt="Logo" />
          </Col>

          {/* Links Section */}
          <Col md={6} className="text-center text-md-left">
            <Row>
              <Col xs={6} md={3}>
                <h6 className="footer-heading">Quick Links</h6>
                <ul className="footer-links">
                  <li><Link to="/" className="footer-link">Home</Link></li>
                  <li><Link to="/budgetbuddy" className="footer-link">Budget Buddy</Link></li>
                  <li><Link to="/stockmarketgame" className="footer-link">SMG</Link></li>
                  <li><Link to="/aboutus" className="footer-link">About Us</Link></li>
                  <li><Link to="/contactus" className="footer-link">Contact Us</Link></li>
                </ul>
              </Col>
              
              <Col xs={6} md={3}>
                <h6 className="footer-heading">Resources</h6>
                <ul className="footer-links">
                  <li><a href="https://www.instagram.com" className="footer-link" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                  <li><a href="https://www.linkedin.com" className="footer-link" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                </ul>
              </Col>
            </Row>
          </Col>

          {/* Copyright Section */}
          <Col md={3} className="text-center text-md-right">
            <p className="footer-copyright">
              Copyright &copy; 2024-2025 teensmoney.org. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
